import { fetchPosts } from '~/hooks/usePosts';

const $ = jQuery.noConflict();

/**
 * Testimonial template
 *
 * @param {object} testimonial testimonial object
 */
const testimonialHTML = testimonial => (
   `<div class="testimonial">
      <p>${testimonial.excerpt}</p>
   </div>`
);

/**
 * Append additional testimonials to the page
 *
 * @param {number} nextPage - Next page number
 * @param {number} pageSize - Posts per page
 */
export async function moreTestimonials(nextPage = 1, pageSize = 16) {
   const posts = await fetchPosts(
      `/wp-json/theme/v1/testimonials&page=${page}&per_page=${max}`
   );
   $('.testimonials-container').append(
      posts.map(testimonialHTML)
   );
   return posts;
}

export function setupTestimonialsPage() {
   let currentPage = 1;
   $(document).ready(() => {
      $('.more-testimonials').on('click', () => {
         currentPage++;
         moreTestimonials(currentPage);
      });
   });
}
